const PENDING = 'typogram_preparation_pending';
const choices = ['typing', 'practice', 'lessons', 'mocks'];

export function rememberNewLearner() {
  try { sessionStorage.setItem(PENDING, '1'); } catch { /* Optional guidance. */ }
}

export function needsPreparationChoice() {
  try { return sessionStorage.getItem(PENDING) === '1'; } catch { return false; }
}

export function finishPreparationChoice() {
  try { sessionStorage.removeItem(PENDING); } catch { /* Navigation still works. */ }
}

export function trackPreparation(event, goal) {
  if (!['preparation_choice', 'preparation_start', 'preparation_tutorial', 'preparation_complete'].includes(event) || !choices.includes(goal)) return false;
  try {
    const consent = JSON.parse(localStorage.getItem('typogram_cookie_consent') || 'null');
    if (consent?.preferences?.analytics !== true || typeof window.gtag !== 'function') return false;
    window.gtag('event', event, {product: 'preparation', goal});
    return true;
  } catch { return false; }
}
